import slugify from 'slugify';

import { createUniqueName } from 'src/lib/createUniqueName';

import {
  API_NAME_MAX_CHAR,
  GRAPH_ID_MAX_CHAR,
  GRAPH_NAME_MAX_CHAR,
} from '../constants';

export const generateSubgraphNameFromEndpoint = (endpoint: string) => {
  try {
    const url = new URL(endpoint);
    const hostnamePieces = url.hostname.split('.');
    const subdomainToFill =
      hostnamePieces.find((name) => name.toLowerCase() !== 'www') ||
      hostnamePieces[0];
    return decodeURIComponent(subdomainToFill)
      .replaceAll(/[^a-zA-Z0-9_-]/g, '-')
      .substring(0, API_NAME_MAX_CHAR);
  } catch {
    return '';
  }
};

export const generateUniqueGraphName = (
  orgName: string = '',
  existingGraphTitles: string[] = [],
) => {
  if (!orgName) return '';

  return createUniqueName(orgName, existingGraphTitles).substring(
    0,
    GRAPH_NAME_MAX_CHAR,
  );
};

/**
 * This function should be used when auto generating graph ids to avoid generating
 * invalid ids when we aren't displaying id errors.
 */
export const generateGraphId = (graphName: string, uniqueString?: string) => {
  const slugifiedGraphName = slugify(graphName, { strict: true }).replace(
    /^[^a-zA-Z]*/,
    '',
  );
  return slugify(
    `${slugifiedGraphName.slice(
      0,
      GRAPH_ID_MAX_CHAR - (uniqueString ? uniqueString.length + 1 : 0),
    )}${slugifiedGraphName.length < 1 ? 'id' : ''}${
      uniqueString ? `-${uniqueString}` : ''
    }`,
    { strict: true },
  ).substring(0, GRAPH_ID_MAX_CHAR);
};
